export default {
    items: [
        // {
        //     name: 'Водителаи', // Extra › Водители › Управление
        //     url: '/buh/drivers',
        //     icon: 'icon-puzzle'
        // },
        // {
        //     name: 'Аналитика НСБ', // НСБ › Система › Аналитика
        //     url: '/buh/analytics',
        //     icon: 'icon-puzzle'
        // },
        // {
        //     name: 'Бухгалтерия НСБ', //НСБ › Система › Бухгалтерия
        //     url: '/buh/analytics',
        //     icon: 'icon-puzzle'
        // },
        {
            name: 'Экспорт данных',
            url: '/buh/dataexport',
            icon: 'icon-cloud-download',
            badge: {
                variant: 'danger',
                text: 'NEW'
            }
        },
        {
            name: 'Импорт данных',
            url: '/buh/dataimport',
            icon: 'icon-cloud-upload',
            badge: {
                variant: 'danger',
                text: 'скоро'
            }
        },
        {
            name: 'Путевки',
            url: '/buh/vouchers',
            icon: 'icon-briefcase'
        },
        {
            name: 'Брони',
            url: '/buh/bookings',
            icon: 'fa fa-calendar-check-o'
        },
        {
            name: 'Финансы',
            url: '/buh/finances',
            icon: 'fa fa-money',
            badge: {
                variant: 'danger',
                text: 'NEW'
            }
        },
        {
            name: 'Балансы',
            url: '/buh/balances',
            icon: 'fa fa-money',
            badge: {
                variant: 'danger',
                text: 'NEW'
            }
        },
        {
            name: 'Платежи',
            url: '/buh/payments',
            icon: 'fa fa-money',
            badge: {
                variant: 'danger',
                text: 'NEW'
            }
        },
        {
            name: 'Объекты отдыха',
            url: '/tech/hotels',
            icon: 'icon-puzzle',
        },
        {
            name: 'Компании',
            url: '/admin/companies',
            icon: 'icon-people'
        },
        {
            name: 'Отчеты',
            url: '/buh/reports',
            icon: 'icon-book-open',
            badge: {
                variant: 'danger',
                text: 'NEW'
            }
        },

    ]
}

